import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material"
import moment, { Moment } from "moment"
import EditIcon from '@mui/icons-material/Edit';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { useCallback, useState } from "react";
import BasicDatePicker from "../BasicDatePicker";

export default function SelectPeriodoSazonal({
    prevValues,
    onChange
}: SelectPeriodoVendasProps) {

    const [openModal, setOpenModal] = useState(false);

    const handleClose = useCallback(() => {
        setOpenModal(false)
    }, [])

    const handleSubmit = useCallback((inputData: SelectPeriodoVendasValues) => {
        onChange(inputData)
        setOpenModal(false)
    }, [onChange])

    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
            >
                <Typography fontSize={12}>Período de vendas</Typography>
                <Box>
                    {moment(prevValues.periodo_inicio).format('DD/MM/YYYY')} até {moment(prevValues.periodo_fim).format('DD/MM/YYYY')}
                    <IconButton aria-label="edit" size="small" onClick={() => setOpenModal(true)}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Box>
                <Chip label={`Sazonal ${moment(prevValues.sazonalidade_inicio).format('DD/MM/YYYY')} até ${moment(prevValues.sazonalidade_fim).format('DD/MM/YYYY')}`} size="small" variant="outlined" color="primary" icon={<CalendarMonthOutlinedIcon />} />
            </Box>

            {
                openModal &&
                <DialogSelectDate
                    defValues={prevValues}
                    {...{ openModal, handleClose, handleSubmit }}
                />
            }
        </>
    )
}

function DialogSelectDate({
    openModal,
    handleClose,
    handleSubmit,
    defValues,
}: DialogSelectDateProps) {

    const [values, setValues] = useState<SelectPeriodoVendasValues>(defValues)

    const handleSelect = useCallback(() => {
        handleSubmit(values)
    }, [handleSubmit, values])

    return (
        <Dialog
            open={openModal}
            onClose={handleClose}
            maxWidth={"xs"}
            fullWidth={true}
        >
            <DialogContent>
                <Typography variant="h6" mb={2}>Período de vendas</Typography>
                <Grid container spacing={1}>
                    <Grid size={{xs:6}}>
                        <BasicDatePicker
                            label="Início"
                            blockFutureDates
                            value={moment(values.periodo_inicio)}
                            onChange={(data) => setValues(prevState => ({ ...prevState, periodo_inicio: data as Moment }))}
                        />
                    </Grid>
                    <Grid size={{xs:6}}>
                        <BasicDatePicker
                            label="Fim"
                            blockFutureDates
                            value={moment(values.periodo_fim)}
                            onChange={(data) => setValues(prevState => ({ ...prevState, periodo_fim: data as Moment }))}
                        />
                    </Grid>
                </Grid>
                <Typography variant="h6" mb={2} mt={3}>Sazonalidade</Typography>
                <Grid container spacing={1}>
                    <Grid size={{xs:6}}>
                        <BasicDatePicker
                            label="Início"
                            blockFutureDates
                            value={moment(values.sazonalidade_inicio)}
                            onChange={(data) => setValues(prevState => ({ ...prevState, sazonalidade_inicio: data as Moment }))}
                        />
                    </Grid>
                    <Grid size={{xs:6}}>
                        <BasicDatePicker
                            label="Fim"
                            blockFutureDates
                            value={moment(values.sazonalidade_fim)}
                            onChange={(data) => setValues(prevState => ({ ...prevState, sazonalidade_fim: data as Moment }))}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    type="button"
                    variant="contained"
                    onClick={handleSelect}
                >
                    Selecionar
                </Button>
            </DialogActions>
        </Dialog>
    )
}


export interface SelectPeriodoVendasValues {
    periodo_inicio: Moment,
    periodo_fim: Moment,
    sazonalidade_inicio: Moment,
    sazonalidade_fim: Moment
}

interface SelectPeriodoVendasProps {
    onChange: (values: SelectPeriodoVendasValues) => void;
    prevValues: SelectPeriodoVendasValues
}

interface DialogSelectDateProps {
    openModal: boolean
    defValues: SelectPeriodoVendasValues
    handleClose: () => void
    handleSubmit: (inputData: SelectPeriodoVendasValues) => void
}